<template>
  <div class="container wc-container wc-container-720">
    <div class="page-settings">
      <div class="settings-item">
        <h4 class="settings-item--label">Registration Confirmation Email</h4>
        <i-switch v-model="form.regConfirmationEnabled" />
      </div>
      <div class="settings-item" v-if="form.regConfirmationEnabled">
        <h4 class="settings-item--label">Email Title</h4>
        <Input v-model="form.regConfirmationTitle" type="text" />
      </div>
      <div class="settings-item" v-if="form.regConfirmationEnabled">
        <h4 class="settings-item--label">Email Content</h4>
        <vue-editor
          :useCustomImageHandler="true"
          @imageAdded="handleImageAdded"
          v-model="form.regConfirmationContent"
        />
      </div>
      <div class="settings-item">
        <Button
          type="primary"
          @click="onUpdateEmailSettings()"
          style="float:right;"
          v-if="!isSaving"
        >Save</Button>
        <Button type="primary" style="float:right;" disable v-if="isSaving">Please wait</Button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
import axios from "axios";
import $config from "@/config";

//import _ from "lodash"

export default {
  components: {
    VueEditor
  },
  data() {
    return {
      form: {
        regConfirmationEnabled: false,
        regConfirmationTitle: null,
        regConfirmationContent: null
      },
      isSaving: false
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    ...mapGetters("emails", {
      emails: "getCopy"
    }),
    ...mapGetters("appsettings", {
      appSettings: "getCopy"
    })
  },
  methods: {
    ...mapActions("emails", {
      updateEmailsAction: "patch",
      findEmailsAction: "find",
      createEmailsAction: "create"
    }),
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      let formData = new FormData();
      formData.append("file", file);

      axios
        .post($config.uploadServer, formData)
        .then(result => {
          let url = result.data;
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch(err => {
          console.log(err);
        });
    },
    onUpdateEmailSettings() {
      this.$data.isSaving = true;
      console.log(this.emails);
      this.updateEmailsAction([this.emails._id, this.form, {}])
        .then(res => {
          this.$Message.success("Email settings has been updated");
          this.$data.isSaving = false;
        })
        .catch(err => {
          console.log(err);
          this.$Message.error("Error on email settings update");
          this.$data.isSaving = false;
        });
    }
  },
  created() {
    this.findEmailsAction({ query: { webcastId: this.webcast._id } }).then(
      response => {
        console.log(response);
        if (response.total == 0) {
          this.createEmailsAction({ webcastId: this.webcast._id }).then(res => {
            console.log(res);
            this.$store.commit("emails/setCurrent", res);
          });
        } else {
          this.form = _.cloneDeep(response.data[0]);
          this.$store.commit("emails/setCurrent", response.data[0]._id);
        }
      }
    );
  }
};

/*
{{webcast-title}}

Date: {{webcast-date}}

Time: {{webcast-time}}



Webcast Link: {{webcast-url}}



Please make sure you didn't share this link with anyone else. It's unique for you
*/
</script>
<style >
.page-settings .settings-item {
  margin-bottom: 16px;
}
</style>

